import { store } from '../store';
import { GetAPIDomain } from './common';
window.WSSocket = null;

let socketInterval = null;
const healthCheckTime = 1000 * 30;
let lastToken = "";

export function ConnectSocket() {
  return new Promise((resolve, reject) => {
    const endpoint = GetAPIDomain("noty", "ap-northeast-2");
    const socketUrl = endpoint;
    const token = store.getState().AuthReducer.token;
    if (token && token === lastToken) {
      if (window?.WSSocket?.readyState?.toString() && window?.WSSocket?.readyState !== 3) {
        resolve(window.WSSocket);  
        return;
      }
    }
    lastToken = token;
    if (!token) {
      resolve(null);
      return;
    }
    const socket = new window.WebSocket(socketUrl + "?token=" + token);
    window.WSSocket = socket;
    socket.onopen = () => {
      if (socketInterval) {
        clearInterval(socketInterval);
      }
      socketInterval = setInterval(() => {
        if (socket.readyState === 3) {
        } else if (socket.readyState === 1) {
          socket.send('ping');
        }
      }, healthCheckTime);
      console.log("websocket is connected.")
      resolve(socket);
    };

    socket.onclose = () => {
      // override method
    };

    socket.onerror = () => {
      // override method
    };

    socket.onmessage = (msg) => {
      // override method
      if (msg.data === "pong") {
        console.log(msg.data);
      } else {
        var payload = JSON.parse(msg.data);
        console.log(payload);
      }
    };
  });
}

export function DisconnectSocket() {
  console.log("DisconnectSocket");
  if (window.WSSocket) {
    window.WSSocket.close();
    // window.WSSocket = null;
    lastToken = "";
  }
}

export function SendSocket(data) {
  if (window.WSSocket && window.WSSocket?.readyState === 1) {
    const payload = JSON.stringify(data);
    window.WSSocket.send(payload);
    return true;
  } else {
    return false;
  }
}
